import { useEffect, useState } from 'react';
import { getGrowthData } from '../../../datafetchers/PregnancyPage';
import BabySize from './BabySize';
import IdealWeightHeight from './IdealWeightHeight';
import ScrollableWeeks from './ScrollableWeeks';
import { GrowthTrackerSection } from './styled';

export default function GrowthTracker(props) {
  const {
    currentWeek,
    setCurrentWeek,
    babyGrowthData,
    margin,
    mediamargin,
    growthTracker,
    location,
  } = props;
  const [growthData, setGrowthData] = useState(babyGrowthData?.[0]);
  const resetGrowthData = async () => {
    const data = await getGrowthData(currentWeek);
    setGrowthData(data?.baby_data?.[0]);
  };
  useEffect(() => {
    resetGrowthData();
  }, [currentWeek]);

  return (
    <GrowthTrackerSection margin={margin} mediamargin={mediamargin}>
      <ScrollableWeeks
        currentWeek={currentWeek}
        setCurrentWeek={setCurrentWeek}
        location={location}
      />
      <IdealWeightHeight growthData={growthData} />
      <BabySize
        growthData={growthData}
        location={location}
        currentWeek={currentWeek}
      />
    </GrowthTrackerSection>
  );
}
